import * as moment from "moment"
import * as _ from "lodash"
import { camelize, snakeize, humanize } from './helpers'

_.mixin({
  camelize: camelize,
  snakeize: snakeize,
  humanize: humanize,

  binarySearch: function(values: any[], compare: (any) => number) {
    let start = 0
    let length = values.length
    let index = Math.floor(length / 2)
    let result = null
    while (length > 0 && (result = compare(values[index])) !== 0) {
      length = Math.floor(length / 2)
      if (result > 0) {
        start = index
        index = start + Math.floor(length / 2)
      } else {
        index = start + Math.floor(length / 2)
      }
    }
    return values[index]
  },

  toAge: function(dateOfBirth, date) {
    let dob = moment(dateOfBirth)
    let now = null
    if (date != null) {
      now = moment(date)
    } else {
      now = moment()
    }
    let years = now.year() - dob.year()
    if (now.month() < dob.month())
      years -= 1
    if (now.month() === dob.month() && now.day < dob.day())
      years -= 1
    return years
  },

  diffKeys: function(objectA: any, objectB: any): string[] {
    return _.reduce(objectA, function(result, value, key) {
      if (_.isEqual(value, objectB[key])) {
        return result
      } else {
        return result.concat(key)
      }
    }, [])
  },

  uniformSubset: function<T>(array: T[], count): any {
    let indicies = _.range(0, array.length, array.length / count)
    return _.map(indicies, function(i) {
      return array[Math.round(i)]
    })
  }
});
